import React, { ReactNode } from "react";

import { Divider, Anchor, createStyles, Stack, Sx } from "@mantine/core";

export type DetailSectionColumnProps = {
  title: ReactNode;
  content?: ReactNode;
  link?: string;
  isV2?: boolean;
};

const useStyles = createStyles({
  content: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    "&>div": {
      overflow: "hidden",
      textOverflow: "ellipsis",
    },
  },
});

export const DetailSectionColumn = ({
  title,
  content,
  link,
  isV2 = false,
}: DetailSectionColumnProps) => {
  const { classes, theme } = useStyles();
  const sx: Sx = isV2
    ? {
        border: `1px solid ${theme.colors.tertiaryBackground[0]}`,
        borderRadius: 6,
        gap: 12,
        padding: "10px 20px",
      }
    : { gap: 0 };
  const Content = (
    <Stack spacing={0} sx={sx}>
      <div>{title}</div>
      <div className={classes.content}>{content}</div>
    </Stack>
  );
  return (
    <>
      {link ? (
        <Anchor target="_blank" rel="noreferrer" href={link} variant="text">
          {Content}
        </Anchor>
      ) : (
        Content
      )}

      {!isV2 && <Divider my="sm" />}
    </>
  );
};
